import React, { useState, FC, useEffect } from 'react'
import style from './FullscreenButton.module.scss'
import screenfull from 'screenfull'
import Icon from '../Icon'
import TooltipWrapper from '../TooltipWrapper'
import isFullscreen from '@bt-react/libs/isFullscreen'

export interface FullscreenButtonProps {
  invert?: boolean
}

async function toggleFullScreen (): Promise<boolean> {

  if (!screenfull.isEnabled) return false

  if (isFullscreen()) {

    try {

      await screenfull.exit()
      return false

    }
    catch (e) {

      return true

    }

  }
  else {

    try {
    
      await screenfull.request()
      return true

    }
    catch (e) {

      return false

    }

  }

}

const FullscreenButton: FC<FullscreenButtonProps> = ({ invert = false }) => {

  const [ fullscreen, setFullscreen ] = useState(isFullscreen())

  const handleChange = () => {

    if (!screenfull.isEnabled) return
    setFullscreen(isFullscreen())

  }

  useEffect(() => {

    if (screenfull.isEnabled) {

      screenfull.on('change', handleChange)

    }

    return () => {

      if (screenfull.isEnabled) {

        screenfull.off('change', handleChange)

      }

    }

  }, [])

  const handleFullscreen = async () => {

    const response = await toggleFullScreen()
    setFullscreen(response)

  }

  return <TooltipWrapper
    dataBdd='fullscreen-button-tooltip'
    tooltipText={fullscreen ? 'Exit full screen' : 'Enter full screen'}
    position='bottom'
  >
    <button className={style['FullscreenButton']} onClick={handleFullscreen} data-bdd='fullscreen-button'>
      {
        fullscreen
          ? <Icon name='compressWide'
            colour={ invert ? 'darkGrey' : 'white'}
            dataBdd='fullscreen-button-exit'
            className={style['FullscreenButton-Icon']}
          />
          : <Icon name='expandWide'
            colour={ invert ? 'darkGrey' : 'white'}
            dataBdd='fullscreen-button-enter'
            className={style['FullscreenButton-Icon']}
          />
      }
    </button>
  </TooltipWrapper>

}

export default FullscreenButton
